angular.module('tgaAdmin').config(['uiSelectConfig',
  function (uiSelectConfig) {
    uiSelectConfig.theme = 'templates/directives/ui-select/select2';
  },
]);
